const getters = {
    isDisabled: (state) => state.survey.sections.globals.questions.codeClient.response != null
};
export default getters;
